import * as React from "react";
import { SVGProps, memo } from "react";

const SvgCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg width={38} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M34.54 23.991 3.127 24C1.68 24 .508 22.808.508 21.334L.5 2.674C.5 1.201 1.671.01 3.118.01L34.54 0c1.447 0 2.618 1.192 2.618 2.666l.009 18.66c-.017 1.465-1.18 2.665-2.627 2.665Z"
      fill="#37A16B"
    />

    <path
      opacity={0.7}
      d="M4.127 2.866a.705.705 0 0 0-.705.705v3.728c0 .39.315.705.705.705h6.468c.39 0 .705-.315.705-.705V3.571a.705.705 0 0 0-.705-.705H4.127Z"
      fill="#fff"
    />

    <path
      opacity={0.7}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.422 12.086a1 1 0 0 0-1 1v.76a1 1 0 0 0 1 1H9.44a1 1 0 0 0 1-1v-.76a1 1 0 0 0-1-1H4.422Zm8.07 0a1 1 0 0 0-1 1v.76a1 1 0 0 0 1 1h5.019a1 1 0 0 0 1-1v-.76a1 1 0 0 0-1-1h-5.019Zm7.07 1a1 1 0 0 1 1-1h5.02a1 1 0 0 1 1 1v.76a1 1 0 0 1-1 1h-5.02a1 1 0 0 1-1-1v-.76Zm9.072-1a1 1 0 0 0-1 1v.76a1 1 0 0 0 1 1h5.018a1 1 0 0 0 1-1v-.76a1 1 0 0 0-1-1h-5.018Z"
      fill="#fff"
    />

    <path
      fill="#000"
      fillOpacity={0.3}
      d="M22.929 17.334h11.723v1.017H22.929zM26.581 19.361h8.071v1.017h-8.071z"
    />
  </svg>
);

const Memo = memo(SvgCreditCard);

export default Memo;
